import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
function TablaProductoLiberacionMaduracion(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_31LiberacionMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProductoLiberacion, handdleRemoveProductosPrevLiberacion, handdleEditProductosPrevLiberacion, productosLiberacion } = api
    // const { productosMap, handdleProductoMap } = props.MapProductos
    const [id, setId] = React.useState()
    const [numerorecipientes, setnumerorecipientes] = React.useState('')
    const [materialrecipientes, setmaterialrecipientes] = React.useState('')
    const [capacidad, setcapacidad] = React.useState('')
    const [informacionadicional, setInformacionAdicional] = React.useState('')
    const [numerolote, setNumeroLote] = React.useState('')
    const [volumen, setVolumen] = React.useState('')
    const [unidad, setUnidad] = React.useState('')
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = []

    columns = [
        {
            field: 'numerorecipientes', headerName: 'No. de recipientes', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerorecipientes}`} arrow>
                        <label>{`${params.row.numerorecipientes} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'materialrecipientes', headerName: 'Material de recipientes', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 170, },

        {
            field: 'capacidad', headerName: 'Capacidad', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.capacidad}`} arrow>
                        <label>{`${params.row.capacidad} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'unidad', headerName: 'Unidad', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.unidad}`} arrow>
                        <label>{`${params.row.unidad} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerolote', headerName: 'Núm. Lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'volumen', headerName: 'Volumen (Litros)', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.volumen}`} arrow>
                        <label>{`${params.row.volumen} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 120,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                        <label>{`${params.row.contenidoalcoholico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'informacionadicional', headerName: 'Información Adicional', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.informacionadicional}`} arrow>
                        <label>{`${params.row.informacionadicional} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) => (

                <Fragment>
                    {fc_31LiberacionMap?.length > 0 ? (
                        <Fragment>
                            
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemoveProductosPrevLiberacion({ data: params.row })
    }

    const botonGuardar = async () => {
        if (capacidad.toString().length > 0 && numerorecipientes.length > 0 && materialrecipientes.length > 0 &&
            numerolote.length > 0 && unidad != '0') {
            let dato = {
                id: id, numerorecipientes: numerorecipientes, materialrecipientes: materialrecipientes, capacidad: capacidad,
                informacionadicional: informacionadicional, numerolote: numerolote, volumen: volumen, contenidoalcoholico: contenidoalcoholico,
                unidad: unidad
            }
            handdleEditProductosPrevLiberacion(dato)
            setnumerorecipientes('')
            setmaterialrecipientes('')
            setcapacidad('')
            setVolumen('')
            setContenidoAlcoholico('')
            setInformacionAdicional('')
            setUnidad('0')
            setNumeroLote('')
            setEditar(false)
            setproductoMap([])
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setnumerorecipientes(params.row.numerorecipientes)
        setmaterialrecipientes(params.row.materialrecipientes)
        setcapacidad(params.row.capacidad)
        setInformacionAdicional(params.row.informacionadicional)
        setNumeroLote(params.row.numerolote)
        setVolumen(params.row.volumen)
        setUnidad(params.row.unidad)
        setContenidoAlcoholico(params.row.contenidoalcoholico)

        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productosLiberacion)
    React.useEffect(() => {
        setRows(productosLiberacion)
    }, [productosLiberacion])

    const botonAgregar = async () => {
        if (capacidad.toString().length > 0 && numerorecipientes.length > 0 && materialrecipientes.length > 0 &&
            numerolote.length > 0 && unidad != '0') {
            let dato = {
                id: uuidv4(), numerorecipientes: numerorecipientes, materialrecipientes: materialrecipientes, capacidad: capacidad,
                informacionadicional: informacionadicional, numerolote: numerolote, volumen: volumen, contenidoalcoholico: contenidoalcoholico,
                unidad: unidad
            }
            handdleProductoLiberacion(dato)
            setnumerorecipientes('')
            setmaterialrecipientes('')
            setcapacidad('')
            setNumeroLote('')
            setVolumen('')
            setUnidad('0')
            setContenidoAlcoholico('')
            setInformacionAdicional('')
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setnumerorecipientes('')
        setmaterialrecipientes('')
        setcapacidad('')
        setInformacionAdicional('')
        setNumeroLote('')
        setVolumen('')
        setUnidad('0')
        setContenidoAlcoholico('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_31LiberacionMap.filter(anexo => anexo.idfc31_anexoliberacionmaduracion === params.row.idfc31_anexoliberacionmaduracion)
        setproductoMap(filtro[0])
        if (params.row.idfc31_anexoliberacionmaduracion) setId(params.row.idfc31_anexoliberacionmaduracion)
        else setId(params.row.idfc31_anexoliberacionmaduracion)
        setnumerorecipientes(params.row.numerorecipientes)
        setmaterialrecipientes(params.row.materialrecipientes)
        setcapacidad(params.row.capacidad)
        setInformacionAdicional(params.row.informacionadicional)
        setNumeroLote(params.row.numerolote)
        setVolumen(params.row.volumen)
        setUnidad(params.row.unidad)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setEditar(true)
    }

    return (
        <>
            <FormGroup><br />
                <div className='row align-items-center'>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="number" min='0' className={`form-control ${productoMap?.liberacioncheck !== undefined ? (productoMap?.liberacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={numerorecipientes} onChange={e => setnumerorecipientes(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Número de recipientes</label>
                            {numerorecipientes.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.liberacioncheck !== undefined ? (productoMap?.liberacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='materialrecipientes'
                                value={materialrecipientes} onChange={e => setmaterialrecipientes(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Material de los recipientes</label>
                        </div>
                        {materialrecipientes.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                        <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="number" className={`form-control ${productoMap?.liberacioncheck !== undefined ? (productoMap?.liberacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={volumen} onChange={e => setVolumen(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Volumen (Litros)</label>
                        </div>
                        <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                    </div>
                    <div className='col-md-5'>
                        <div className="form-floating mb-2">
                            <input type="number" min='0' className={`form-control ${productoMap?.liberacioncheck !== undefined ? (
                                productoMap?.liberacioncheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={capacidad} onChange={e => setcapacidad(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Capacidad`} arrow>
                                <label htmlFor='floatingInput'>Capacidad (Litros)</label>
                            </Tooltip>
                        </div>
                        {capacidad.length <= 0 ? <>
                            <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                        <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                    </div>
                    <div className='col-xs-12 col-sm-12 col-md-2 col-xl-2 col-xxl-2'>
                        <div className="form-floating mb-3">
                            <select
                                name="unidad"
                                value={unidad}
                                onChange={e => setUnidad(e.target.value)}
                                className={`form-select ${productoMap?.liberacioncheck !== undefined ? (
                                    productoMap?.liberacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} >
                                <option value="0" >Unidad</option>
                                <option value="L">L</option>
                                <option value="mL">mL</option>
                                <option value="CL">CL</option>
                                <option value="cm">cm³</option>
                                <option value="hl">hl</option>
                            </select>
                            <label htmlFor='floatingInput'></label>
                            {unidad == '0' && <span className='text-danger'>Obligatorio</span>}
                        </div>
                    </div>

                    <div className='col-md-5 mt-2'>
                        <div className="form-floating mb-2">
                            <input type="number" min='0' className={`form-control ${productoMap?.liberacioncheck !== undefined ? (
                                productoMap?.liberacioncheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={contenidoalcoholico} onChange={e => setContenidoAlcoholico(e.target.valueAsNumber)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Contenido Alcohólico`} arrow>
                                <label htmlFor='floatingInput'>% Alc. Vol.</label>
                            </Tooltip>
                        </div>
                        {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                            <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                        }
                        <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                    </div>
                    <div className='col-md-3'>
                        <div className="form-floating mb-3">
                            <input type="text" min='0' className={`form-control ${productoMap?.liberacioncheck !== undefined ? (productoMap?.liberacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={numerolote} onChange={e => setNumeroLote(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Número de lote</label>
                            {numerolote.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.liberacioncheck !== undefined ? (productoMap?.liberacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                value={informacionadicional} onChange={e => setInformacionAdicional(e.target.value)}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>Información adicional</label>
                            {/*informacionadicional.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''*/}
                            <span className='text-danger'>{productoMap?.liberacioncheck ? productoMap?.liberacion : ''}</span>
                        </div>
                    </div>
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_31LiberacionMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '102%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )

}
export default TablaProductoLiberacionMaduracion